import { render, staticRenderFns } from "./companyView.vue?vue&type=template&id=2ebacfca&"
import script from "./companyView.vue?vue&type=script&lang=js&"
export * from "./companyView.vue?vue&type=script&lang=js&"
import style0 from "./companyView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports